// window._mfq.push(["setVariable", "KEY", "VALUE"]);

let _initialized = false;

window._mfq = window._mfq || [];

export const init = (cb) => {
  if (_initialized) {
    return console.warn(`Mouseflow has already been initialized`);
  }

  const script = document.createElement("script");

  script.onload = function () {
    cb?.();
  };

  script.type = "text/javascript";
  script.defer = true;
  script.src =
    "//cdn.mouseflow.com/projects/5cf34a5b-74e7-4d2d-9bbf-f3f9ee46e895.js";

  document.getElementsByTagName("head")[0].appendChild(script);

  _initialized = true;
};

const exec = (data) => {
  if (!_initialized) {
    return console.error(`Mouseflow needs to be initialized first`);
  }

  try {
    if (!Array.isArray(window._mfq)) {
      console.error(
        `Mouseflow has not been properly initialized, 'window._mfq' is not an array, got ${window._mfq}`
      );
    }

    window._mfq?.push(data);
  } catch (error) {
    console.error("Mouseflow", error);
  }
};

export const setVariable = (key, value) => {
  exec(["setVariable", key, value]);
};

export const tag = (value) => {
  exec(["tag", value]);
};
